import { AgentPermitsService } from "../../../services/AgentPermitsService"
import { useEffect, useMemo } from "react"
import Button from "../../../components/form-controls/Button"
import { useForm } from "react-hook-form"
import { AlertService } from "../../../services/Alert"
import { useCurrentAccount } from "../../../hooks/useCurrentAccount"
import { useTranslation } from "react-i18next"
import useRequest from "../../../hooks/useRequest"
import Loader from "../../../components/Loader"
function AgentPermitsPartial() {

    const { t } = useTranslation();
    const {call, isRequesting} = useRequest();
    const { account } = useCurrentAccount();

    const defaultValues = {
        id: 0,
        account_id: 0,
        add_contacts: 1,
        add_event: 1,
        block_ticket: 1,
        open_ticket_contacts: 1,
        redirect_ticket: 1,
        reopen_ticket: 1,
        schedule_message: 1,
        set_status: 1,
        show_attach: 1,
        show_calendar: 1,
        show_contacts: 1,
        show_emojis: 1,
        show_historical: 1,
        show_tickets: 1,
    }

    const { register, handleSubmit, watch, reset, formState: { isValid, isSubmitting,  } } = useForm({
        mode: 'onChange',
        defaultValues
    });

    const submit = async(data) => {
        try {
            data.add_contacts = data.add_contacts ? 1: 0;
            data.add_event = data.add_event ? 1: 0;
            data.block_ticket = data.block_ticket ? 1: 0;
            data.open_ticket_contacts = data.open_ticket_contacts ? 1: 0;
            data.redirect_ticket = data.redirect_ticket ? 1: 0;
            data.reopen_ticket = data.reopen_ticket ? 1: 0;
            data.schedule_message = data.schedule_message ? 1: 0;
            data.set_status = data.set_status ? 1: 0;
            data.show_attach = data.show_attach ? 1: 0;
            data.show_calendar = data.show_calendar ? 1: 0;
            data.show_contacts = data.show_contacts ? 1: 0;
            data.show_emojis = data.show_emojis ? 1: 0;
            data.show_historical = data.show_historical ? 1: 0;
            data.show_tickets = data.show_tickets ? 1: 0;

            await AgentPermitsService.updatePermissions(data)

            AlertService.success('¡Éxito!', "Se ha guardado con éxito la configuración de permisos del agente")
        } catch (error) {
            console.error(error);
            AlertService.error('¡Error!',  'No se pudo guardar el estado del agente, intenta más tarde')
        }
    }
    

    const getPermissions = async() => {
        const { data } = await call (() => AgentPermitsService.getPermissions(account.id));
        reset(data)
    }

    useEffect(() => {
        getPermissions();
    }, [])
    
    const heightRequesting = useMemo(()=> {return isRequesting ? 'h-200':''},[isRequesting]);
    return (
        <>
            <div className="card">

                <div className="card-header d-flex align-items-center">
                    <div className="me-3">
                        <h2 className="card-title h4">{t("config.agent-permissions.agent-title")}</h2>
                    </div>

                </div>

                <div className={`card-body relative ${heightRequesting}`}>
                    {
                        isRequesting ? <Loader/> :
                    <>
                    <div className="row">
                        <div className="col-5">
                            <h5>{t("config.agent-permissions.message-title")}</h5>
                            <p>{t("config.agent-permissions.message-p")}</p>
                        </div>
                        <div className="col-7">
                            <div className="form-check mb-3">
                                <input type="checkbox" className="form-check-input" id={`set_status`} {...register('set_status')} />
                                <label className="form-check-label" htmlFor={`set_status`} >{t("config.agent-permissions.checkbox-status")}</label>
                            </div>
                            <div className="form-check mb-3">
                                <input type="checkbox" className="form-check-input" id={`show_historical`} {...register('show_historical')}/>
                                <label className="form-check-label" htmlFor={`show_historical`} >{t("config.agent-permissions.checkbox-history")}</label>
                            </div>
                            <div className="form-check mb-3">
                                <input type="checkbox" className="form-check-input" id={`redirect_ticket`} {...register('redirect_ticket')}/>
                                <label className="form-check-label" htmlFor={`redirect_ticket`} >{t("config.agent-permissions.checkbox-ticket")}</label>
                            </div>
                            <div className="form-check mb-3">
                                <input type="checkbox" className="form-check-input" id={`block_ticket`} {...register('block_ticket')}/>
                                <label className="form-check-label" htmlFor={`block_ticket`} >{t("config.agent-permissions.checkbox-block")}</label>
                            </div>
                            <div className="form-check mb-3">
                                <input type="checkbox" className="form-check-input" id={`schedule_message`} {...register('schedule_message')}/>
                                <label className="form-check-label" htmlFor={`schedule_message`} >{t("config.agent-permissions.checkbox-message")}</label>
                            </div>
                            <div className="form-check mb-3">
                                <input type="checkbox" className="form-check-input" id={`show_emojis`} {...register('show_emojis')}/>
                                <label className="form-check-label" htmlFor={`show_emojis`} >{t("config.agent-permissions.checkbox-emojis")}</label>
                            </div>
                            <div className="form-check mb-3">
                                <input type="checkbox" className="form-check-input" id={`show_attach`} {...register('show_attach')}/>
                                <label className="form-check-label" htmlFor={`show_attach`} >{t("config.agent-permissions.checkbox-documents")}</label>
                            </div>
                        </div>
                    </div>
                    <hr />

                    
                    <div className="row">
                        <div className="col-5">
                            <h5>{t("config.agent-permissions.contacts-title")}</h5>
                            <p>{t("config.agent-permissions.contacts-p")}</p>
                        </div>
                        <div className="col-7">
                            <div className="form-check mb-3">
                                <input type="checkbox" className="form-check-input" id={`show_contacts`} {...register('show_contacts')}/>
                                <label className="form-check-label" htmlFor={`show_contacts`} >{t("config.agent-permissions.checkbox-contacts")} </label>
                            </div>
                            <div className="form-check mb-3">
                                <input type="checkbox" className="form-check-input" id={`add_contacts`} {...register('add_contacts', { disabled: !(!!watch('show_contacts')) })}/>
                                <label className="form-check-label" htmlFor={`add_contacts`} >{t("config.agent-permissions.checkbox-add")} </label>
                            </div>
                            <div className="form-check mb-3">
                                <input type="checkbox" className="form-check-input" id={`open_ticket_contacts`} {...register('open_ticket_contacts', { disabled: !(!!watch('show_contacts')) })}/>
                                <label className="form-check-label" htmlFor={`open_ticket_contacts`} >{t("config.agent-permissions.checkbox-open-contact")} </label>
                            </div>
                            
                        </div>
                    </div>
                    <hr />

                    
                    <div className="row">
                        <div className="col-5">
                            <h5>{t("config.agent-permissions.tickets-title")}</h5>
                            <p>{t("config.agent-permissions.tickets-p")}</p>
                        </div>
                        <div className="col-7">
                            <div className="form-check mb-3">
                                <input type="checkbox" className="form-check-input" id={`show_tickets`} {...register('show_tickets')}/>
                                <label className="form-check-label" htmlFor={`show_tickets`} >{t("config.agent-permissions.checkbox-show")} </label>
                            </div>
                            <div className="form-check mb-3">
                                <input type="checkbox" className="form-check-input" id={`reopen_ticket`} {...register('reopen_ticket', { disabled: !(!!watch('show_tickets')) } )}/>
                                <label className="form-check-label" htmlFor={`reopen_ticket`} >{t("config.agent-permissions.checkbox-reopen")} </label>
                            </div>
                            
                        </div>
                    </div>
                    <hr />

                    
                    <div className="row">
                        <div className="col-5">
                            <h5>{t("config.agent-permissions.calendar-title")}</h5>
                            <p>{t("config.agent-permissions.contacts-p")}</p>
                        </div>
                        <div className="col-7">
                            <div className="form-check mb-3">
                                <input type="checkbox" className="form-check-input" id={`show_calendar`} {...register('show_calendar')}/>
                                <label className="form-check-label" htmlFor={`show_calendar`} >{t("config.agent-permissions.checkbox-show-calendar")} </label>
                            </div>
                            <div className="form-check mb-3">
                                <input type="checkbox" className="form-check-input" id={`add_event`} {...register('add_event', { disabled: !(!!watch('show_calendar')) })}/>
                                <label className="form-check-label" htmlFor={`add_event`} >{t("config.agent-permissions.checkbox-add-event")} </label>
                            </div>
                        </div>
                    </div>
                    

                    <div className="d-flex justify-content-end">
                        <Button type="submit" className="btn btn-primary btn-sm" disabled={!isValid} isLoading={isSubmitting} onClick={handleSubmit(submit)}>{t("btn-save")}</Button>
                    </div>

                    </>
                    }   
                </div>
            </div>
        </>
    )
}
export default AgentPermitsPartial